<template>
  <div class="text-center">
    <form class="form-signin">
      <img class="mb-4" src="../../static/logo-ionis-education-group.png" alt="" width="250" height="128">
      <label for="inputEmail" class="sr-only">Adresse email</label>
      <input type="email" id="inputEmail" class="form-control" placeholder="Adresse email" required autofocus v-model="email">
      <label for="inputPassword" class="sr-only">Mot de passe</label>
      <input type="password" id="inputPassword" class="form-control" placeholder="Mot de passe" required v-model="password">
      <div class="alert alert-danger" v-show="error_form">
        {{ message }}
      </div>
      <button class="mt-3 btn btn-lg btn-primary btn-block" type="submit" @click.prevent="auth">Connexion</button>
      <p class="mt-3">
        <router-link to="/reset">
          <a>Vous avez oublié votre mot de passe ?</a>
        </router-link>
        </p>
    </form>
  </div>
</template>

<script>
import Vuex from 'vuex'

export default {
  data () {
    return {
      email: '',
      error_form: false,
      message: '',
      password: ''
    }
  },
  computed: {
    ...Vuex.mapGetters(['domain', 'ttl'])
  },
  methods: {
    ...Vuex.mapActions(['addAccessToken', 'addActive', 'addCity', 'addEstablishment', 'addRole', 'addSchool', 'addUserId']),
    auth () {
      this.error = false
      if (this.email !== '' && this.password !== '') {
        this.$http.post(this.domain + '/api/ionis/login', { email: this.email, password: this.password, ttl: this.ttl }, { emulateJSON: true }).then((response) => {
          response.json().then((data) => {
            let tokenUser = data.id
            let idUser = data.userId
            this.$http.get(this.domain + '/api/ionis/' + data.userId + '?access_token=' + data.id, { emulateJSON: true }).then((response) => {
              response.json().then((data) => {
                console.log(data)
                if (!data.active) {
                  this.addAccessToken('')
                  this.addUserId('')
                  this.error_form = true
                  this.message = 'Votre compte a été désactivé.'
                } else if (data.role === 'API') {
                  this.error_form = true
                  this.message = 'Vos identifiants sont invalides.'
                  this.addAccessToken('')
                  this.addUserId('')
                } else {
                  this.addAccessToken(tokenUser)
                  this.addUserId(idUser)
                  this.addRole(data.role)
                  this.addActive(data.active)
                }
              })
            }, (response) => {

            })
            if (data.role !== 'API') {
              this.$http.get(this.domain + '/api/establishments_ionis?filter[include][establishment]=school&filter[include][establishment]=city&&filter[where][ionisId]=' + data.userId + '&access_token=' + data.id, { emulateJSON: true }).then((response) => {
                response.json().then((data) => {
                  let establishments = []
                  let schools = []
                  let cities = []
                  for (let i = 0; i < data.length; i++) {
                    establishments.push(data[i].establishmentId)
                    // if (!schools.includes(data[i].establishment.schoolId)) {
                    //   schools.push(data[i].establishment.schoolId)
                    // }
                    // if (!cities.includes(data[i].establishment.cityId)) {
                    //   cities.push(data[i].establishment.cityId)
                    // }
                    let school = schools.find(a => a.id === data[i].establishment.schoolId)
                    if (school === undefined) {
                      schools.push(data[i].establishment.school)
                    }
                    let city = cities.find(a => a.id === data[i].establishment.cityId)
                    if (city === undefined) {
                      cities.push(data[i].establishment.city)
                    }
                  }
                  this.addEstablishment(establishments)
                  this.addSchool(schools.sort(this.compare))
                  this.addCity(cities.sort(this.compare))
                  this.$router.push('/events')
                })
              }, (response) => {

              })
            }
          })
        }, (response) => {
          response.json().then((data) => {
            this.error_form = true
            this.message = 'Vos identifiants sont invalides.'
          })
        })
      } else {
        this.error_form = true
        this.message = 'Vous devez renseigner vos identifiants.'
      }
    },
    compare (a, b) {
      const nameA = a.name.toUpperCase()
      const nameB = b.name.toUpperCase()
      let comparison = 0

      if (nameA > nameB) {
        comparison = 1
      } else if (nameA < nameB) {
        comparison = -1
      }

      return comparison
    }
  }
}
</script>

<style scoped>
@import "../../static/signin.css";
</style>



// WEBPACK FOOTER //
// src/components/Login.vue